const newPhoneCode = state => (state.newPhoneCode !== null ? state.newPhoneCode : {})

const phoneCodes = (state) => {
  let result = state.phoneCodes && Object.keys(state.phoneCodes).length > 0 ? Object.values(state.phoneCodes) : []
  return result
}

const categories = (state) => (locale) => {
  let cats = Object.values(state.categories)
  let filtered = cats.filter((b) => b.locale.toUpperCase() === locale.toUpperCase())
  return filtered
}

const getCategoryById = (state) => (id, locale) => {
  let cats = Object.values(state.categories)
  let filtered = cats.filter((b) => b.locale.toUpperCase() === locale.toUpperCase())
  let byId = filtered.filter((b) => b.id.toUpperCase() === id.toUpperCase())
  return byId[0]
}

const articles = (state) => {
  let result = state.articles && Object.keys(state.articles).length > 0 ? Object.values(state.articles) : []
  return result
}

const getLanguageById = (state) => (id) => {
  let languages = Object.values(state.languages)
  let filtered = languages.filter((b) => b.id.toUpperCase() === id.toUpperCase())
  return filtered[0]
}

export default {
  newPhoneCode,
  phoneCodes,
  categories,
  getCategoryById,
  articles,
  getLanguageById
}



// WEBPACK FOOTER //
// ./src/store/modules/icg/getters.js